import React, { Component } from 'react'
import ReactDOM from 'react-dom'

const appRoot = document.getElementById('root')


export class Modal extends Component {
  constructor () {
    super()
    this.el = document.createElement('div')
    this.el.classList.add('Modal')
  }

  componentDidMount () {
    appRoot.appendChild(this.el);
    const _modal = document.querySelector('.Modal')
    const _video = _modal.querySelector(`.FullScreen .content-wrap .content div .full_screen_video .video_${this.props.videoIndex} video`)
    console.log(_modal)
    console.log(_video)
    if(_video) {
      _video.addEventListener('loadeddata', () => {
        if (_video.readyState >= 2) {
          console.log(_video.readyState)
          _video.play()
        }
      })
    }
  }

  componentWillUnmount () {
    appRoot.removeChild(this.el)
  }

  render () {
    return ReactDOM.createPortal(
      this.props.children,
      this.el,
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modal/index.js